import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { LayoutService } from './../../../../services/layout.service';
import { DocScrollerComponent } from './../../../../shared/doc-scroller/doc-scroller.component';
import { GalleryService } from '../../gallery.service';

@Component({
  selector: 'app-gallery-search-results',
  templateUrl: './gallery-search-results.component.html',
  styleUrls: ['./gallery-search-results.component.scss']
})
export class GallerySearchResultsComponent implements OnInit {
  @ViewChild(DocScrollerComponent, { static: true }) scroller: DocScrollerComponent;
  isHandset = false;

  query = '';

  constructor(
    private route: ActivatedRoute,
    private layoutService: LayoutService,
    private galleryService: GalleryService
  ) {}

  async ngOnInit(): Promise<void> {
    const queryParams = this.route.snapshot.queryParamMap;
    if (queryParams.has('q')) {
      // have query passed in
      this.query = queryParams.get('q');
    }
    this.isHandset = await this.layoutService.$isHandset.pipe(take(1)).toPromise();
    this.search();
  }

  search(cursors?: Map<number, any[]>): void {
    this.scroller.setQueryObservables([
      this.galleryService.getKeywordSearchObservable(this.query, this.isHandset ? 1 : 4, cursors)
    ]);
    this.scroller.fetch();
  }

  async reset(searchTerm): Promise<void> {
    this.query = searchTerm;
    await this.scroller.reset();
    this.search();
  }
}
